import PropTypes from 'prop-types';
import { Tab } from '@headlessui/react';
import Modal from '../../components/Modal/Modal';

const DeleteConfirmModal = ({
                              open, onClose, deleteFunction, data
                          }) => {

    const onCloseButtonClickHandler = () => {
        onClose();
    };

    const onSubmitHandler = async () => {
        deleteFunction(data.orderId);
        onCloseButtonClickHandler();
    };

    return (
        <Modal open={open} setOpen={onCloseButtonClickHandler}>
            <div className="px-2">
                <Tab.Group>
                    <Tab.Panels>
                        <h2 className="font-bold">Are you sure you want to delete order SA_{data.orderId} ?</h2>
                        <h2>This action cannot be undone. Once deleted, the order will be permanently removed from the system.</h2>
                        <div className="flex flex-row w-full justify-around pt-2">
                            <button
                                type="submit"
                                onClick={() => onClose()}
                                className="focus:outline-none text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                                aria-label="Cancel Delete"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                onClick={() => onSubmitHandler()}
                                className="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900"
                                aria-label="Confirm Delete"
                            >
                                Yes I want to delete
                            </button>
                        </div>
                    </Tab.Panels>
                </Tab.Group>
            </div>
        </Modal>
    );
};

DeleteConfirmModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    deleteFunction: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
};

export default DeleteConfirmModal;
